import { SectionsState } from '../../types/Sections';
import {
  SectionsActionTypes,
  SET_QUALIFICATIONS,
  SET_SECTIONS,
  SET_ASSESSMENTS,
  SET_COMPONENTS,
  SET_FILE_RESULTS,
  SET_ARE_FILES_LOADING,
  SET_FILES_TOTAL,
  SET_FILES_NEXT_PAGE_URL,
  SET_IS_DOWNLOAD_FILES_LOADING,
} from './types';
import { GlobalActionTypes } from '../types';
import { unknown } from '../actions';

export const initialState: SectionsState = {
  qualifications: [],
  assessments: [],
  components: [],
  sections: [],
  hasError: false,
  nextPageUrl: undefined,
  fileResults: undefined,
  areFilesLoading: false,
  filesTotal: 0,
  isDownloadFilesLoading: false,
};

export default (state = initialState, action: SectionsActionTypes | GlobalActionTypes = unknown()): SectionsState => {
  switch (action.type) {
    case SET_QUALIFICATIONS: {
      const {
        payload: { qualifications },
      } = action;

      return { ...state, qualifications };
    }

    case SET_ASSESSMENTS: {
      const {
        payload: { assessments },
      } = action;

      return { ...state, assessments };
    }

    case SET_COMPONENTS: {
      const {
        payload: { components },
      } = action;

      return { ...state, components };
    }

    case SET_SECTIONS: {
      const {
        payload: { sections },
      } = action;

      return { ...state, sections };
    }

    case SET_ARE_FILES_LOADING: {
      const {
        payload: { isLoading },
      } = action;

      return {
        ...state,
        areFilesLoading: isLoading,
      };
    }

    case SET_FILE_RESULTS: {
      const {
        payload: { fileResults },
      } = action;

      return { ...state, fileResults };
    }

    case SET_FILES_TOTAL: {
      const {
        payload: { total },
      } = action;

      return {
        ...state,
        filesTotal: total,
      };
    }

    case SET_FILES_NEXT_PAGE_URL: {
      const {
        payload: { nextUrl },
      } = action;

      return {
        ...state,
        nextPageUrl: nextUrl,
      };
    }

    case SET_IS_DOWNLOAD_FILES_LOADING: {
      const {
        payload: { isLoading },
      } = action;

      return {
        ...state,
        isDownloadFilesLoading: isLoading,
      };
    }

    default:
      return state;
  }
};
